import React, { useMemo } from "react";

import { ProductCategories } from "@/custom-types/Directus";
import { useSelector } from "@/redux/hooks";
import { getState } from "@/redux/selectors/location";
import { getTargetedData } from "@/utils/getTargetedData";

import CoinList from "../CoinList";

type Props = {
  className?: string;
  productCategories?: ProductCategories<string>[];
};

/*
 * Map Directus category names to icon names.
 * This should be temporary until we confirm
 * that we can update the names in Directus.
 * https://leafly.atlassian.net/browse/NL-2596
 */
const getCategoryName = (name: string) => {
  const CAT_LOOKUP: Record<string, string> = {
    accessories: "Accessory",
    cartridges: "Cartridge",
    concentrates: "Concentrate",
    "delta-8 thc": "Delta8",
    edibles: "Edible",
    "hemp cbd": "HempCBD",
    "pre-rolls": "Preroll",
    seeds: "Seed",
    topicals: "Topical",
    vaping: "Vape",
  };
  return CAT_LOOKUP[name.toLowerCase()] || name;
};

const HomePageProductCategories: React.FunctionComponent<Props> = ({
  className = "",
  productCategories = [],
}: Props) => {
  const userState = useSelector(getState).toLocaleLowerCase();

  const coinListData = useMemo(() => {
    const orderedProductCategories = productCategories.sort(
      (a, b) => (a.order || 0) - (b.order || 0),
    );
    const gatheredProductCategories = getTargetedData(
      orderedProductCategories,
      userState,
    );

    return gatheredProductCategories.map((category) => {
      return {
        icon: `coinList/${getCategoryName(category.name || "").toLowerCase()}.svg`,
        label: category.name || "",
        url: category.url || category.shop_url || undefined,
        value: category.name || "",
      };
    });
  }, [productCategories, userState]);

  return (
    <div className={className}>
      <div className="container">
        <CoinList
          title="Shop by category"
          coinData={coinListData}
          impressionEventCategory="Homepage Products"
        />
      </div>
    </div>
  );
};

export default HomePageProductCategories;
